import React from "react";
import DashboardContext from "./DashboardContext";
import DashboardNew from "./DashboardNew";

export default function DashboardNewContextProvider() {
  return (
    <DashboardContext>
      <DashboardNew />
    </DashboardContext>
  );
}
